
<template>
    <div class="row">
        <div class="col-12 journey-page-section" v-if="viewingDetails">
            <div class="journey-page">
                <a class="skip-main" href="#main">Skip to main content</a>
                <breadcrumb></breadcrumb>
                <div class="sticky-bar bg-white" ref="stickyBar">
                    <hr class="my-0">
                    <ViewingJourneyStickyBar></ViewingJourneyStickyBar>
                    <hr class="my-0">
                </div>
                <div class="container"  id="main" tabindex="-1">
                    <div class="row bg-light-gray px-6 py-3 align-items-center mt-4 rounded-10 mx-0">
                        <div class="col-lg-7">
                            <h2>We’ve based your return on an appointment length of: </h2>
                            <p>You can change this to recalculate your return journey</p>
                        </div>
                        <div class="col-lg-3 mt-3 mt-lg-0 ">
                            <vue-select class="bg-white"
                                id="selectTime"
                                :options="option.hours"
                                v-model="selectedTime"
                                @input="setSelected"
                                >
                             </vue-select>
                        </div>
                        <div class="col-lg-2 mt-3 mt-lg-0">
                            <button class="btn btn-primary update-btn w-100" :disabled="!this.hasChanged" type="button"  @click="updateJourney">
                                Update
                            </button>
                        </div>
                    </div>
                    <div id="details" class="row my-4 journey-details scroll-offset details" ref='details'>
                        <div class="col-12 row">
                            <div class="col-4">
                                <h2 class="title-text">Journey details</h2>

                            </div>
                            <div v-if="currentJourney && currentJourney.depart.stages == 'taxi'" class="col-8 d-flex text-right justify-content-end pr-0">
                                <button data-toggle="modal" data-target="#taxi" class="btn btn-outline-secondary">
                                <svg-icon :name="this.brand + '/taxi'" width="24"></svg-icon>
                                    Find local taxi operators
                                </button>
                            </div>

                            <div class="modal fade" id="taxi" tabindex="-1" role="dialog"  aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                    <div class="modal-content">
                                        <div class="mb-4 row">
                                            <div class="col-12 d-flex mt-4">
                                                <div class=" col-6 p-0 " >
                                                    <h2 class="taxi-title">Local taxi operators</h2>
                                                </div>
                                                <div class="col-6">
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <p class="close-modal-button close-taxi" aria-hidden="true">Close</p>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-6 float-left">
                                                <taxis :journey-type="journeyType"></taxis>
                                            </div>
                                            <div class="col-6 float-right taxi-modal-text pt-2 mt-2">
                                                <p> If you call a taxi operator, tell them where and when you want to be picked up and dropped off. The price displayed in your journey plan is an <strong>estimate only.</strong></p>
                                                <p> Calls are charged at your communication provider rate. Check with your provider before you dial </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="currentJourney && currentJourney.depart.stages == 'community transport'" class="col-8 d-flex text-right justify-content-end pr-0">
                                <button data-toggle="modal" data-target="#community" class="btn btn-outline-secondary">
                                <svg-icon :name="this.brand + '/phone'" width="24"></svg-icon>
                                    Contact provider
                                </button>
                            </div>
                            <div class="modal fade" id="community" tabindex="-1" role="dialog"  aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                                    <div class="modal-content">
                                        <div class="mb-4 row">
                                            <div class="col-12 d-flex mt-4">
                                                <div v-if="currentJourney.depart.stages == 'community transport'" class=" col-6 p-0 " >
                                                   <p><strong>{{currentJourney.ct_operator.name}}</strong></p>
                                                </div>
                                                <div class="col-6">
                                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <p class="close-modal-button close-taxi" aria-hidden="true">Close</p>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-8 float-left">
                                                <community-transport :details="currentJourney.ct_operator"></community-transport>
                                            </div>
                                            <div class="col-4 float-right taxi-modal-text pt-2 mt-2">
                                                <p> The price displayed in your journey plan is an <strong>estimate only.</strong></p>
                                                <p> Calls are charged at your communication provider rate. Check with your communication provider before you dial </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <journey-details v-if="currentJourney" :journey="currentJourney" :showingReturn="showingReturn" @toggleJourneyType="showingReturn = !showingReturn"></journey-details>
                    </div>
                    <div class="row mt-5 map-of-journey scroll-offset" id="map" ref='map'>
                        <div class="col-md-3 col-sm-12">
                            <h2 class="title-text">Map of journey</h2>
                        </div>
                        <JourneyMapComponent></JourneyMapComponent>
                    </div>
                    <div class="row">
                        <div class="col-12 mt-5 steps-journey scroll-offset" id="steps-journey" ref='stepByStep'>
                            <h2  class="title-text" tabindex="0" >Step-by-step guide</h2>
                            <loading :isLoading="isLoading"></loading>
                            <div v-if="!isLoading" class="row">
                                <div class="col-12 mb-3">
                                    <hr>
                                </div>
                                <div class="col-lg-7 col-md-7">
                                    <stage-steps :selectedTime="selectedTime" :journey="currentJourney" @showDetails="showDetails"></stage-steps>
                                </div>
                                <div class="col-lg-4 col-sm-12 col-md-4 offset-md-1 mb-3 mt-3">
                                    <!-- <h2>Alternative return option</h2>
                                    <p>Select below to see an alternative return journey should your appointment end earlier or later than expected:</p>
                                    <button type="button" class="btn btn-primary px-4 py-3 mt-3 rounded-pill d-flex align-items-center justify-content-center w-100"
                                        @click="alternativeReturn(true)">
                                        <h3 class="d-inline mb-0">Show me an early return option</h3>
                                        <svg-icon aria-labelledby="arrow right icon" class="ml-3" :name="this.brand +'/arrow-right'" width="24" height="auto"></svg-icon>
                                    </button>
                                    <button type="button" class="btn btn-primary px-4 py-3 mt-3 rounded-pill d-flex align-items-center justify-content-center w-100"
                                        @click="alternativeReturn()">
                                        <h3 class="d-inline mb-0">Show me a later return option</h3>
                                        <svg-icon aria-labelledby="arrow right icon"  class="ml-3" :name="this.brand + '/arrow-right'" width="24" height="auto"></svg-icon>
                                    </button> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 journey-page-section" v-if="!viewingDetails">
            <nav class="navbar navbar-light bg-white mt-3 px-4">
                <div class="container d-flex justify-content-end">
                    <a  href @click.prevent="showJourney">
                        <strong>&lt; Back to journey details</strong>
                    </a>
                </div>
            </nav>
            <stage-details @goBack="showJourney" :stage="selectedStage">
            </stage-details>
            <div class="container px-4">
                <div class="row">
                    <div class="col-0 mt-4">
                        <h2 class="title-text">Stage steps</h2>
                        <hr>
                        <div class="row mt-5">
                            <div class="col-lg-12 col-md-12">
                                <stage-directions
                                    @navigate="navigateStage"
                                    :step="selectedStage"
                                    :showNext="showNext()"
                                    :showPrevious="showPrevious()"
                                ></stage-directions>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 print-journey-page">
            <print-journey></print-journey>
        </div>
    </div>
</template>
<script>
import JourneyDetails from '@/components/JourneyDetails.vue'
import StageDetails from '@/components/StageDetails.vue'
import moment from 'moment'
import Loading from '@/components/Loading.vue'
import StageDirections from '@/components/StageDirections.vue'
import StageSteps from '@/components/StageSteps.vue'
import breadcrumb from '@/components/Breadcrumb.vue'
import ViewingJourneyStickyBar from '@/components/ViewingJourneyStickyBar.vue'
import {
    mapGetters, mapActions, mapState, mapMutations,
} from 'vuex'
import JourneyMapComponent from '@/components/JourneyMapComponent.vue'
import mutationsMapping from '@/store/mutations-mapping'
import PrintJourney from '@/components/PrintJourney.vue'
import Taxis from '@/components/Taxis.vue'
import CommunityTransport from '@/components/CommunityTransport.vue'

const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    name: 'journey',
    components: {
        JourneyDetails,
        StageDetails,
        PrintJourney,
        Loading,
        StageDirections,
        StageSteps,
        breadcrumb,
        JourneyMapComponent,
        ViewingJourneyStickyBar,
        Taxis,
        CommunityTransport,
    },
    data() {
        return {
            journeyType: 'depart',
            brand: whitelabel.brand,
            journey: {},
            viewingDetails: true,
            selectedStage: {},
            selectedStageIndex: null,
            showingReturn: true,
            showDepartStepsOffset: 1000,
            showReturnStepsOffset: 1000,
            hasChanged: false,
            option: {
                hours: [
                    { label: '30 minutes', value: 30, disabled: false },
                    { label: '1 hour', value: 60, disabled: false },
                    { label: '1 hour 30 minutes', value: 90, disabled: false },
                    { label: '2 hours', value: 120, disabled: false },
                    { label: '2 hours 30 minutes', value: 150, disabled: false },
                    { label: '3 hours', value: 180, disabled: false },
                ],
            },

            form: {
                origin: this.origin,
                destination: this.destination,
                arrive_time: this.arriveDateAndTime,
                return_time: '',
                has_access_to_car: this.hasAccessToCar,
                has_concessionary_pass: this.hasConcessionaryPass,
                has_railcard: !!this.railcardType,
                railcard_type: this.railcardType,
                arrive_by_buffer: '20',
            },
            selectedTime: {},
        }
    },
    mounted() {
        this.fetchJourney()
        if (this.currentJourney) {
            this.initSelectedTime()
        }
    },
    computed: {
        ...mapGetters([
            'getJourneyById',
        ]),
        ...mapState([
            'currentJourney',
            'isLoading',
            'origin',
            'destination',
            'arriveDate',
            'arriveTime',
            'arriveDateAndTime',
            'railcardType',
            'hasAccessToCar',
            'hasConcessionaryPass',
            'via',
            'searchQuery',
        ]),
        steps() {
            return this.currentJourney ? [...this.currentJourney.depart.steps, ...this.currentJourney.return.steps] : []
        },
        taxis() {
            return this.currentJourney.return ? [...this.currentJourney.depart.taxis, ...this.currentJourney.return.taxis] : [...this.currentJourney.depart.taxis]
        },
    },
    methods: {
        ...mapActions([
            'retrieveSingleJourney',
            'updateReturnTime',
        ]),
        ...mapMutations(mutationsMapping),
        navigateStage(type) {
            if (type === 'forward') {
                this.selectedStageIndex += 1
            } else {
                this.selectedStageIndex -= 1
            }
            this.selectedStage = this.steps[this.selectedStageIndex]
            window.scrollTo(0, 0)
        },
        showDetails(step, index) {
            window.scrollTo(0, 0)
            this.viewingDetails = false
            this.selectedStage = step
            this.selectedStageIndex = index
        },
        showJourney() {
            this.viewingDetails = true
            this.selectedStage = {}
            this.selectedStageIndex = 0
        },
        showNext() {
            return this.steps.length >= this.selectedStageIndex + 2
        },
        showPrevious() {
            return this.selectedStageIndex > 0
        },
        resolveStepPosition(index) {
            return (index === this.currentJourney.return.steps.length - 1) ? 'last' : 'middle'
        },
        alternativeReturn(early = false) {
            const updatedTime = moment(this.searchQuery.return_time, 'HH:mm')
            if (early) {
                updatedTime.subtract(30, 'minutes')
            } else {
                updatedTime.add(30, 'minutes')
            }
            this.clearResults()
            this.updateReturnTime({
                hash: this.$route.params.hash,
                params: { return_time: updatedTime.format('YYYY/MM/DD HH:mm:ss') },
                router: this.$router,
            })
        },
        updateJourney() {
            const updatedTime = this.getUpdatedTime()
            this.clearResults()
            this.updateReturnTime({
                hash: this.$route.params.hash,
                params: { return_time: updatedTime },
                router: this.$router,
            })
        },
        getUpdatedTime() {
            const returnTime = moment(this.currentJourney.return_departure_at)
            return returnTime.add(this.selectedTime.value - this.currentJourney.appointment_length, 'minutes').format('YYYY/MM/DD HH:mm:ss')
        },
        initSelectedTime() {
            this.selectedTime = { label: this.currentJourney.appointment_length_label, value: this.currentJourney.appointment_length, disabled: false }
        },
        setSelected(value) {
            if (value.value === this.selectedTime.value) {
                this.hasChanged = true
            } else {
                this.hasChanged = false
            }
        },
        showSteps(type) {
            if (type === 'depart') {
                this.showDepartStepsOffset = this.currentJourney.depart.steps.length + 1
            } else {
                this.showReturnStepsOffset = this.currentJourney.return.steps.length + 1
            }
        },
        fetchJourney() {
            const currentJourney = this.getJourneyById(this.$route.params.journeyId)
            if (currentJourney) {
                this.setCurrentJourney(currentJourney.journey)
            } else {
                this.retrieveSingleJourney({
                    hash: this.$route.params.hash,
                    journeyID: this.$route.params.journeyId,
                    successCallback: this.initSelectedTime,
                })
            }
        },
        goToHome() {
            this.$router.push({ name: 'Home' })
        },
    },
}
</script>
<style >
.scroll-offset{
    scroll-margin-top: 6rem;
}
.taxi-title{
    font-size: 1.25rem
}
.title-text{
    font-size: 22px;
    font-weight: bold;
}
</style>
